import { createContext, useContext } from "react";

const CheckboxContext = createContext();

export const CheckboxProvider = ({ children, checked }) => (
    <CheckboxContext.Provider value={ checked }>
        { children }
    </CheckboxContext.Provider>
);

export const useCheckbox = () => {
    const checkbox = useContext(CheckboxContext);

    return checkbox;
};
